import styled from 'styled-components'
import { palette } from '../../Styles/colors'
import { media } from '../../Styles/media'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 4em;

  ${media.tablet`
    width: calc(90% * (1/1) - 1em - 1px);
    margin: 1em;
    align-self: center;
  `}

  ${media.desktop`
    width: calc(100% * (1/2) - 1em - 1px);
    margin: 1em;
    &:only-child {
      width: calc(75% * (1/1) - 1em - 1px);
      max-width: 1000px;
    }
  `}
`

const Container = styled.div`
  width: 100%;
  background: ${palette.lightone};
  color: ${palette.base};
  border-radius: 7px 7px 0 7px;
  box-shadow: 5px 5px 5px rgba(0,0,0,0.3);
  padding: 1em 0;
  z-index: 1;
`

const Writting = styled.div`
  h2 {
    font-family: RobotoMonoItalic, monospace, sans-serif;
    color: ${palette.base};
    padding: 0 1.5em;
    line-height: 1.5em;
  }

  p {
    white-space: pre-wrap;
    font-family: RobotoMonoLightItalic, monospace, sans-serif;
    padding: 0 2em;
  }
`

// const Title = styled.h2`
//   font-family: RobotoMonoItalic;
//   color: ${palette.base};
//   padding: 0 1.5em;
// `
// const Text = styled.p`
//   white-space: pre-wrap;
//   font-family: RobotoMonoLightItalic;
//   padding: 0 2em;
// `

const Images = styled.section`
  margin: 2.5em 0;
  display: flex;
  flex-direction: column;
`

const Image = styled.img`
  width: 100%;
  margin: 0;
`

const Label = styled.div`
  align-self: flex-end;
  background: ${palette.lightone};
  border-radius: 0 0 7px 7px;
  padding: 0.5em 1em 0.2em 1em;
  position: relative;
  bottom: 0.2em;

  h2 {
    font-family: VT323Regular, monospace, sans-serif;
    font-size: 1.6em;
    text-transform: uppercase;
    color: ${palette.base};
  }

  ${media.tablet`
    h2 { font-size: 1.2em; }
  `}
`

export { Content, Container, Writting, Images, Image, Label }



// WEBPACK FOOTER //
// ./src/Components/Project/styles.js